import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import LoadingSpinner from '../../../../common/LoadingSpinner';
import SubstitutionOrderLineRow from './SubstitutionOrderLineRow';
import OrderContext from '../../OrderContext';

export default function SubstitutionOrderLines({ loading, orderLines, disableEditing }) {
    const { orderHeader } = useContext(OrderContext);

    const [subs, setSubs] = useState([]);

    useEffect(() => {
        let subList = [];
        orderLines.forEach((substitute, index) => {
            subList.push(
                substitute.subOut && (
                    <SubstitutionOrderLineRow
                        key={substitute.subOut.productCode}
                        orderLine={substitute.subOut}
                        className={index % 2 === 1 ? 'stripe' : ''}
                        disableEditing={true}
                    />
                )
            );
            subList.push(
                substitute.subIn && (
                    <SubstitutionOrderLineRow
                        key={substitute.subIn.productCode}
                        orderLine={substitute.subIn}
                        className={index % 2 === 1 ? 'stripe' : ''}
                        disableEditing={disableEditing}
                    />
                )
            );
        });
        setSubs(subList);
    }, [orderLines, disableEditing]);

    return (
        <div>
            <Table className={'product-range-table'}>
                <thead>
                    <tr>
                        <th className={'image-column centered column-7'}>Image</th>
                        <th className={'column-7'}>Source</th>
                        <th className={'column-7'}>Code</th>
                        <th>Description</th>
                        <th className={'column-9'}>Unit Size</th>
                        <th className={'column-9'}>Invoice Cost</th>
                        <th className={'column-7'}>RSP</th>
                        <th className={'column-7'}>Margin</th>
                        {orderHeader.orderStatus === 'OPEN' ? (
                            <th className={'centered column-7'}>Quantity</th>
                        ) : (
                            <>
                                <th className={'centered column-7'}>Ordered</th>
                                <th className={'centered column-7'}>Accepted</th>
                            </>
                        )}
                        {(orderHeader.orderStatus === 'DELIVERED' ||
                            orderHeader.orderStatus === 'INVOICED') && (
                            <th className={'centered column-7'}>Delivered</th>
                        )}
                        <th className={'centered column-7'}>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={11}>
                                <LoadingSpinner />
                            </td>
                        </tr>
                    ) : (
                        subs.length > 0 && subs
                    )}
                </tbody>
            </Table>
        </div>
    );
}
